import { render, staticRenderFns } from "./CcRadioGroupIcon.ts.vue?vue&type=template&id=83d81634"
import script from "./CcRadioGroupIcon.ts.vue?vue&type=script&lang=ts"
export * from "./CcRadioGroupIcon.ts.vue?vue&type=script&lang=ts"
import style0 from "./CcRadioGroupIcon.ts.vue?vue&type=style&index=0&id=83d81634&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports